import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { Card } from '@onefootprint/ui';
import type { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import CardTitle, { CardError, CardSkeleton } from '../card-title';
import DocumentRow from './components/document-row';
import useOnboardingDocuments from './hooks/use-onboarding-documents';
type OnboardingDocumentsProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
  ref?: Ref<HTMLElement>;
};
const OnboardingDocuments = t0 => {
  const $ = _c(24);
  const {
    entity,
    onboarding,
    ref
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.documents"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    documents,
    error
  } = useOnboardingDocuments(entity, onboarding);
  if (!documents) {
    let t2;
    if ($[1] !== error) {
      t2 = error ? <CardError error={error} /> : <CardSkeleton />;
      $[1] = error;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (!documents.length) {
    return null;
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== documents.length || $[8] !== t3) {
    t4 = <CardTitle title={t3} count={documents.length} />;
    $[7] = documents.length;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== documents || $[11] !== entity) {
    let t6;
    if ($[13] !== entity) {
      t6 = document => <li key={document.id}><DocumentRow entity={entity} document={document} /></li>;
      $[13] = entity;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = documents.map(t6);
    $[10] = documents;
    $[11] = entity;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <Card.Body className="px-4 py-1.5"><ul>{t5}</ul></Card.Body>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <Card.Root>{t4}{t6}</Card.Root>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== ref || $[21] !== t2 || $[22] !== t7) {
    t8 = <section ref={ref} aria-label={t2} tabIndex={-1} className="outline-none">{t7}</section>;
    $[20] = ref;
    $[21] = t2;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default OnboardingDocuments;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.title;
}